'use strict';

const tileImage = require('../utils/tileImage');
const searchUtils = require('../utils/searchUtils');

var debounce = require('lodash/debounce');
var endpoint = $('.suggestions-wrapper').data('url');
var UP_KEY = 38;
var DOWN_KEY = 40;
var DIRECTION_DOWN = 1;
var DIRECTION_UP = -1;

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    let $suggestionsWrapper = searchUtils.getSuggestionsWrapper(this).empty();

    $.spinner().stop();

    if (typeof (response) !== 'object') {
        $suggestionsWrapper.append(response).show();
        // display overlay to block the background interactions
        searchUtils.showOverlay();
        if (searchUtils.isMobileSearch(this)) {
            searchUtils.positionSuggestions(this);
            searchUtils.toggleSuggestionsIcon('close');
            $(this).siblings('.reset-button').addClass('d-block').removeClass('d-none d-sm-block');
            searchUtils.applyModals(this);

            searchUtils.setSuggestionsOffset(this);
            searchUtils.bindViewportRecompute(this);
        } else {
            $(this).siblings('.reset-button').addClass('d-sm-block');
            let $searchDesktopWrapper = $(this).closest('.search-desktop');

            if ($searchDesktopWrapper.length) {
                $searchDesktopWrapper.find('form').append($suggestionsWrapper);
            }
        }

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        let suggestionsList = $('.suggestions .item');
        if ($(suggestionsList).length) {
            $('input.search-field').attr('aria-describedby', 'search-result-count');
        } else {
            $('input.search-field').removeAttr('aria-describedby');
        }

        // find image-container to apply hover effects when products are found
        $('#searchProductGrid .image-container').each(function (index, element) {
            tileImage.initHoverImageContainer($(element));
        });

        // find image-container to apply hover effects in default grid
        $('#searchProductGridFromSlot .image-container').each(function (index, element) {
            tileImage.initHoverImageContainer($(element));
        });
    } else {
        $suggestionsWrapper.hide();
        searchUtils.hideOverlay();
    }
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    $.ajax({
        context: scope,
        url: endpoint + encodeURIComponent($(scope).val()),
        method: 'GET',
        success: processResponse,
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(direction) {
    // get all li elements in the suggestions list
    var suggestionsList = $('.suggestions .item');
    if (suggestionsList.filter('.selected').length === 0) {
        suggestionsList.first().addClass('selected');
        $('input.search-field').each(function () {
            $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
        });
    } else {
        suggestionsList.each(function (index) {
            var idx = index + direction;
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(this).removeAttr('aria-selected');
                if (suggestionsList.eq(idx).length !== 0) {
                    suggestionsList.eq(idx).addClass('selected');
                    suggestionsList.eq(idx).attr('aria-selected', true);
                    $(this).removeProp('aria-selected');
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.eq(idx)[0].id);
                    });
                } else {
                    suggestionsList.first().addClass('selected');
                    suggestionsList.first().attr('aria-selected', true);
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
                    });
                }
                return false;
            }
            return true;
        });
    }
}

module.exports = function () {
    // eslint-disable-next-line consistent-return
    $('form[name="simpleSearch"]').submit(function (e) {
        if (($(this).find('.general-search-input')).val().trim() === '') {
            return false;
        }
        var suggestionsList = $('.suggestions .item');
        if (suggestionsList.filter('.selected').length !== 0) {
            e.preventDefault();
            suggestionsList.filter('.selected').find('a')[0].click();
        }
    });

    $('input.search-field').each(function () {
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        var debounceSuggestions = debounce(getSuggestions, 300);
        $(this).on('keyup focus', function (e) {
            // Capture Down/Up Arrow Key Events
            switch (e.which) {
                case DOWN_KEY:
                    handleArrow(DIRECTION_DOWN);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                case UP_KEY:
                    handleArrow(DIRECTION_UP);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                default:
                    debounceSuggestions(this, e);
            }
        });
    });

    $('body').on('click', function (e) {
        if (!$('.suggestions').has(e.target).length && !$(e.target).hasClass('search-field')) {
            $('.suggestions').hide();
            searchUtils.clearModals();
            $('.search-mobile .suggestions').unbind('scroll');
            searchUtils.hideOverlay();
        }
    });

    $('body').on('click touchend', '.search-mobile button.fa-close', function (e) {
        e.preventDefault();
        $('.suggestions').hide();
        searchUtils.toggleSuggestionsIcon('search');
        searchUtils.tearDownSuggestions();
        searchUtils.hideOverlay();
    });

    $('.site-search .reset-button').on('click', function () {
        if (searchUtils.isMobileSearch(this)) {
            $(this).removeClass('d-block').addClass('d-none');
        } else {
            $(this).removeClass('d-sm-block');
        }
    });

    $('body').on('click', '.search-overlay', function () {
        $('.suggestions').hide();
        searchUtils.toggleSuggestionsIcon('search');
        searchUtils.clearModals();
        searchUtils.hideOverlay();
    });

    // Remove a single last search word
    $('body').on('click', '.last-search-section .js-remove-recent', function (e) {
        e.preventDefault();
        var $li = $(this).closest('li.suggestions__item');
        var term = ($li.data('term') || '').toString();
        var $section = $(this).closest('.last-search-section');
        var removeUrl = $section.data('remove-url');
        if (!term || !removeUrl) {
            return;
        }
        $.ajax({
            url: removeUrl,
            method: 'GET',
            data: {
                term: term
            },
            success: function () {
                $li.remove();
                if (!$section.find('li.suggestions__item').length) {
                    $section.remove();
                }
            }
        });
    });

    // Clear all last search words
    $('body').on('click', '.last-search-section .js-clear-recent', function (e) {
        e.preventDefault();
        var $section = $(this).closest('.last-search-section');
        var clearUrl = $section.data('clear-url');
        if (!clearUrl) {
            return;
        }
        $.ajax({
            url: clearUrl,
            method: 'GET',
            success: function () {
                $section.remove();
            }
        });
    });
};
